import React from 'react';
import { getDigitalInvitesCatalogMedia } from '@/lib/digitalInvitesCatalogMedia';
import { DigitalInvitesPhoneMockup } from './DigitalInvitesPhoneMockup';

export function DigitalInvitesCatalogPreview({ modelId, theme, themeLabel, showPlay, showMusic }) {
  const media = getDigitalInvitesCatalogMedia(modelId);

  if (!media) {
    return (
      <DigitalInvitesPhoneMockup
        theme={theme}
        themeLabel={themeLabel}
        showPlay={showPlay}
        showMusic={showMusic}
      />
    );
  }

  return (
    <div className="relative mx-auto w-full max-w-[220px] sm:max-w-[240px]">
      <div
        className="absolute -inset-4 rounded-[2.5rem] bg-gradient-to-br from-amber-500/15 via-transparent to-violet-500/10 blur-xl pointer-events-none"
        aria-hidden
      />
      <div className="relative rounded-[2rem] border border-white/10 bg-slate-950/90 p-2 shadow-[0_30px_80px_-24px_rgba(0,0,0,0.55)] backdrop-blur-md">
        <div className="absolute top-3 left-1/2 -translate-x-1/2 w-16 h-1.5 rounded-full bg-black/80 z-10" aria-hidden />
        <div className="relative overflow-hidden rounded-[1.35rem] aspect-[9/16] bg-slate-950">
          {media.type === 'video' ? (
            <video
              src={media.src}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              className="h-full w-full object-cover object-top"
            />
          ) : (
            <img
              src={media.src}
              alt=""
              loading="lazy"
              decoding="async"
              className="h-full w-full object-cover object-top"
            />
          )}
        </div>
      </div>
    </div>
  );
}
